export enum NotificationCode {
  TransactionalError = "TRANSACTIONAL_ERROR",
  Availability = "AVAILABILITY",
  OddsChanged = "ODDS_CHANGED",
  HandicapChanged = "HANDICAP_CHANGED",
  OddsAvailability = "ODDS_AVAILABILITY",
  OddsHandicap = "ODDS_HANDICAP",
  HandicapAvailability = "HANDICAP_AVAILABILITY",
  OddsHandicapAvailability = "ODDS_HANDICAP_AVAILABILITY",
  NotCombinable = "NOT_COMBINABLE",
  InsufficientFunds = "INSUFFICIENT_FUNDS",
  MaxPayoutDailyLimit = "MAX_PAYOUT_DAILY_LIMIT",
  MaxPayoutInfo = "MAX_PAYOUT_INFO",
  AboveMaxStake = "ABOVE_MAX_STAKE",
  BelowMinStake = "BELOW_MIN_STAKE",
  AboveMaxPayout = "ABOVE_MAX_PAYOUT",
  IncrementOutOfRage = "INCREMENT_OUT_OF_RANGE",
}
